import { Link } from "@tanstack/react-router";
import { BrandLogo } from "@/components/BrandLogo";

const messages: Record<string, { title: string; body: string; error?: boolean }> = {
  connected: {
    title: "Linear connected",
    body: "Rivets can now receive delegated issues and report agent progress back to Linear.",
  },
  "error-claimed": {
    title: "Linear workspace already connected",
    body: "That Linear workspace belongs to another Rivets organization.",
    error: true,
  },
  verify: {
    title: "Return to the Rivets app",
    body: "Open the Rivets app on this device to finish connecting. The app confirms it started this connection before anything is saved.",
  },
  "error-binding": {
    title: "Connection not completed",
    body: "This connection was started somewhere else. Start it again from Rivets settings.",
    error: true,
  },
  error: {
    title: "Linear connection failed",
    body: "Rivets could not complete OAuth authorization. Return to settings and try again.",
    error: true,
  },
};

export function LinearConnectedPage() {
  const result = new URLSearchParams(window.location.search).get("linear") ?? "error";
  const message = messages[result] ?? messages.error!;

  return (
    <main className="auth-shell">
      <section className="auth-card" aria-live="polite">
        <BrandLogo className="auth-logo" size={22} />
        <div className="panel" style={{ textAlign: "center", padding: 24 }}>
          <div
            aria-hidden="true"
            style={{
              width: 38,
              height: 38,
              margin: "0 auto 16px",
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              border: `1px solid ${message.error ? "var(--danger)" : "var(--success)"}`,
              color: message.error ? "var(--danger)" : "var(--success)",
              fontSize: "var(--glyph-xl)",
            }}
          >
            {message.error ? "!" : "✓"}
          </div>
          <h1 className="auth-title" style={{ marginBottom: 8 }}>{message.title}</h1>
          <p className="auth-subtitle" style={{ margin: "0 auto 20px", maxWidth: 360 }}>{message.body}</p>
          <Link className="btn btn-primary btn-block" to="/">Open Rivets app</Link>
        </div>
      </section>
    </main>
  );
}
